import GetParamURL from '../Helpers/GetParamURL';
let URLParams = GetParamURL();

const initialState = {
    HandleError: {
        PageElement: false,
        Input: false,
    },

    HandleModal: {
        Value: null,
    },
    Config: {
        SitioId: URLParams?.SitioId,
        Modo: URLParams?.Modo,
        URLCallback: URLParams?.URLCallback,
        Data: false,
        Pin: null,
        ActionAuto: false,
        UserEmail: URLParams?.UserEmail,
    },
    HandleToast: false,
    RecaptchaRef: null,
};

const storeReducer = (state, action) => {
    switch (action.type) {
        case 'ERROR PAGE COMPONENT': {
            return {
                ...state,
                HandleError: {
                    PageElement: action.value,
                },
            };
        }
        case 'SET_RECAPTCHA': {
            return {
                ...state,
                RecaptchaRef: action.value,
            };
        }
    }
    return state;
};
export { initialState, storeReducer };
